import { TrendMetricCard } from "../components/TrendMetricCard"
import { EngagementKpiGrid, EngagementSectionCard, SectionSubtitle, SectionTitle } from "./styled"
import { TopEngagedDevicesTable } from "./TopEngagedDevicesTable"
import type { EngagementKpiMetric, ThermostatWeeklyTrend, TopDevice } from "./types"
import { WeeklyTrendChart } from "./WeeklyTrendChart"

const thermostatSeries = [
  { key: "clicks" as const, label: "Clicks on Logo", color: "#3b82f6" },
  { key: "scans" as const, label: "QR Scans", color: "#a855f7" },
]

interface ThermostatEngagementProps {
  kpis: EngagementKpiMetric[]
  weeklyTrend: ThermostatWeeklyTrend[]
  topDevices: TopDevice[]
}

export const ThermostatEngagement = ({ kpis, weeklyTrend, topDevices }: ThermostatEngagementProps) => (
  <EngagementSectionCard>
    <div>
      <SectionTitle>Thermostat Engagement</SectionTitle>
      <SectionSubtitle>Customer interactions on thermostat devices</SectionSubtitle>
    </div>
    <EngagementKpiGrid>
      {kpis.map(metric => (
        <TrendMetricCard key={metric.id} metric={metric} />
      ))}
    </EngagementKpiGrid>
    <WeeklyTrendChart data={weeklyTrend} series={thermostatSeries} />
    <TopEngagedDevicesTable devices={topDevices} />
  </EngagementSectionCard>
)
